import { faCheck, faChevronDown, faChevronUp, faGear, faSpinner } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';
import { Card, Collapse } from 'react-bootstrap';
import { snakeToTitleCase } from '../../utils/string-utils';

interface ToolMetadataBoxProps {
    toolName: string;
    metadata?: Record<string, any>;
    isRunning: boolean;
}

const ToolMetadataBox: React.FC<ToolMetadataBoxProps> = ({ toolName, metadata, isRunning }) => {
    const [open, setOpen] = useState(false);

    return (
        <Card className="mb-2 rounded assistant-tool-box">
            <Card.Header
                onClick={() => setOpen(!open)}
                aria-controls="metadata-collapse"
                aria-expanded={open}
                className="d-flex justify-content-between align-items-center text-muted"
                style={{ cursor: 'pointer' }}
            >
                <div>
                    <FontAwesomeIcon icon={isRunning ? faGear : faCheck} spin={isRunning} className="me-2" />
                    {isRunning && <span>Running </span>}<strong>{toolName ? snakeToTitleCase(toolName) : "Unknown Tool"}</strong>
                </div>
                <FontAwesomeIcon icon={open ? faChevronUp : faChevronDown} />
            </Card.Header>

            <Collapse in={open}>
                <div id="metadata-collapse">
                    <Card.Body>
                        {metadata && (
                            <div className="mb-2">
                                <strong>Metadata:</strong>
                                <pre className="bg-light p-2 rounded">{JSON.stringify(metadata, null, 2)}</pre>
                            </div>
                        )}
                    </Card.Body>
                </div>
            </Collapse>
        </Card>
    );
};

export default ToolMetadataBox;
